export enum DownloadItemTypeEnum {
    images = "images",
    videos = "videos",
}
